import { FieldErrors } from "react-hook-form";

export const getErrorMessage = (
  requiredMessage: string,
  type: "email" | "phoneNumber",
  errors: FieldErrors,
) => {
  if (errors && errors[type] && errors[type]!.type === "required") {
    return requiredMessage;
  }

  return errors && errors[type] ? errors[type]!.message : "";
};
